interface FriendAcceptTextProps {
  friendAcceptText?: { title: string; subtitle: string };
}

const FriendAcceptText: React.FC<FriendAcceptTextProps> = ({ friendAcceptText = { title: brsc.alarm_friend_request, subtitle: brsc.chat_request_popup } }) => {
  return (
    <div className="my-4 flex w-full flex-col items-center gap-[var(--spacing-sm)] px-4">
      <div className="typography-headline-lg text-balance break-keep text-center text-dialog-txt-default">{friendAcceptText.title}</div>
      <div className="typography-body-sm text-center text-dialog-txt-secondary">{friendAcceptText.subtitle}</div>
    </div>
  );
};

export default FriendAcceptText;
